import { render } from "./compentency-index.vue?vue&type=template&id=5583f74a"
import script from "./compentency-index.vue?vue&type=script&lang=js"
export * from "./compentency-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__